module.exports = __webpack_public_path__ + "img/an-old-kitchen-counter-3257923.75d42d0c.jpg";